import React, { useState } from "react"
import { Input, Grid, Button, Checkbox, Image } from "semantic-ui-react"
import VehicleModal from "./VehicleModal"
import BulkUploadModal from "../../components/shared/BulkUploadModal"
import { useTranslation } from "react-i18next"
import {
  isFleetAdvise,
  isFleetMaintenanceHubCanada,
  isFleetcor,
  isMobilease
} from "../../helpers/affiliationHelpers"
import UploadIcon from "../../assets/images/UploadIcon.png"
import DownloadIcon from "../../assets/images/DownloadIcon.png"
import { DRIVER } from "../../constants/roles"
import VehicleReassignmentModal from "../shared/VehicleReassignmentModal"
import { canAddVehicle } from "../../helpers/userRoleHelpers"
export default function VehicleSearch({
  loadVehicles,
  dispatch,
  language,
  currentUser,
  vehicles = [],
  loadAllVehicles
}) {
  const { t } = useTranslation("vehicleIndex")
  const [modalOpen, setModalOpen] = useState(false)

  const userRoles = currentUser?.roles || []
  const isUserOnlyDriver = userRoles.length === 1 && userRoles[0] === DRIVER

  const handleDownloadClick = async () => {
    await dispatch({
      type: "VEHICLES_LOAD_SAGA",
      payload: {
        download: true,
        language: language,
        isDomainShellCanada: isFleetMaintenanceHubCanada()
      }
    })
  }
  return (
    <div className="vehicle-search">
      {isFleetcor(currentUser) && (
        <>
          <Button primary onClick={() => setModalOpen(true)} className="btn-margin-right">
            {t("vehicleReassignmentTitle")}
          </Button>
          <VehicleReassignmentModal
            open={modalOpen}
            onClose={() => setModalOpen(false)}
            loadAllVehicles={loadAllVehicles}
          />
        </>
      )}
      <Button.Group>
        {isFleetcor(currentUser) || isUserOnlyDriver || !canAddVehicle(currentUser) ? (
          ""
        ) : (
          <>
            <VehicleModal completionCallback={loadVehicles} loadAllVehicles={loadAllVehicles}>
              <Button>
                {isFleetAdvise() || isMobilease() ? (
                  <Image src={UploadIcon} className="vehicle-icons" />
                ) : null}
                {t("addVehicleLabel")}
              </Button>
            </VehicleModal>
            <Button.Or text={t("orLabel")} />
            <BulkUploadModal completionCallback={loadVehicles} loadAllVehicles={loadAllVehicles}>
              <Button
                className={`last-button ${
                  isFleetAdvise() || isMobilease() ? "btn-margin-right" : ""
                }`}
              >
                {isFleetAdvise() || isMobilease() ? (
                  <Image src={UploadIcon} className="vehicle-icons" />
                ) : null}
                {t("bulkUploadLabel")}
              </Button>
            </BulkUploadModal>
          </>
        )}
      </Button.Group>
      <Button
        onClick={handleDownloadClick}
        disabled={vehicles.length === 0}
        style={{ display: "flex", alignItems: "center" }}
      >
        {isFleetAdvise() || isMobilease() ? (
          <Image src={DownloadIcon} className="vehicle-icons" />
        ) : null}
        {t("services:downloadLabel")}
      </Button>
    </div>
  )
}
